import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

const ContextMenu = ({ hidden, classes, children, contentPosition }) => {
  return (
    <div
      className={classNames(classes.wrapper, {
        [classes.hidden]: hidden,
      })}
    >
      <div
        className={classNames(classes.verticalContent, {
          [classes.alignItemsRight]: contentPosition === 'right',
        })}
      >
        {children}
      </div>
    </div>
  )
}

ContextMenu.propTypes = {
  classes: PropTypes.shape({
    wrapper: PropTypes.string,
    verticalCenterContent: PropTypes.string,
    hidden: PropTypes.string,
  }).isRequired,
  hidden: PropTypes.bool.isRequired,
  children: PropTypes.node,
  contentPosition: PropTypes.string,
}

export default ContextMenu
